import { CalendarOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import CIQDatePicker from "components/custom-date-picker";
import { Moment } from "moment";
import { useState, useImperativeHandle, forwardRef } from "react";

type Props = {
  value?: Moment | null;
  disabled?: boolean;
  onChange: (value: Moment | null, dateString: string) => void;
  disabledDate?: (current: Moment) => boolean;
  renderExtraFooter?: (mode: any) => React.ReactNode;
  title?: string;
  icon?: React.ReactNode;
};

const DatePickerWithIcon = forwardRef((props: Props, ref: any) => {
  const {
    value,
    disabled = false,
    onChange,
    disabledDate,
    renderExtraFooter,
    title,
    icon = <CalendarOutlined />
  } = props;

  const [openDatePicker, setOpenDatePicker] = useState(false);
  useImperativeHandle(ref, () => ({
    close() {
      setOpenDatePicker(false);
    }
  }));

  return (
    <div>
      <Tooltip title={title}>
        <Button
          disabled={disabled}
          className="border-0 w-[20px] h-[20px] text-ciq-primary-900 hover:!text-ciq-primary-800 bg-transparent hover:!bg-ciq-primary-800 hover:!bg-opacity-5"
          style={{ fontSize: "inherit" }}
          icon={icon}
          onClick={() => {
            setOpenDatePicker(true);
          }}
          data-testid="datepickerwithicon-button"
        />
      </Tooltip>
      <CIQDatePicker
        className="h-0 w-0 p-0 m-0 border-0 border-none bg-white ciq-date-picker"
        allowClear={false}
        open={openDatePicker}
        onOpenChange={() => setOpenDatePicker(false)}
        value={value}
        onChange={onChange}
        disabledDate={disabledDate}
        renderExtraFooter={renderExtraFooter}
      />
    </div>
  );
});
export default DatePickerWithIcon;
